// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { taskService } from './features/task/services/taskService';
import { taskDetailsService } from './features/task/services/taskDetailsService';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDoZWsm9ltwJsdJEa_sBFwjPaK8-Qz-gMA",
  authDomain: "tykven-se-app.firebaseapp.com",
  projectId: "tykven-se-app",
  storageBucket: "tykven-se-app.firebasestorage.app",
  messagingSenderId: "928794584861",
  appId: "1:928794584861:web:754c5578435a8e7ccce3f4",
  measurementId: "G-CB8VQCBQJL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Check if messaging is supported before initializing
const isMessagingSupported = () => {
  return 'Notification' in window && 
         'serviceWorker' in navigator && 
         'PushManager' in window;
};

let messaging = null;
if (isMessagingSupported()) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase Messaging not supported in this browser:', error);
  }
}
// Helper function to get Firebase auth access token
const getFirebaseAccessToken = async () => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      unsubscribe();
      if (user) {
        try {
          const accessToken = await user.getIdToken();
          resolve(accessToken);
        } catch (error) {
          console.error('Error fetching Firebase access token:', error);
          resolve(firebaseConfig.apiKey);
        }
      } else {
        resolve(firebaseConfig.apiKey);
      }
    });
  });
};

class FirebaseNotificationService {
  constructor() {
    this.navigatorKey = null;
    this.vapidKey = "BOPP-Po0SbtZCtqS_-dVcofSQ7J4n-AbV_jwqb6zHijpXDJmU7pqs09_X8f2nD-DTiTJadAMaQDCk96Ni8xzpNU";
    this.fetchMaintenanceDetailsCallback = null;
    this.fetchTaskListCallback = null;
  }

  setFetchMaintenanceDetailsCallback(callback) {
    this.fetchMaintenanceDetailsCallback = callback;
  }

  setFetchTaskListCallback(callback) {
    this.fetchTaskListCallback = callback;
  }

  async initialize(navKey = null) {
    try {
      this.navigatorKey = navKey;
      
      await this._requestPermission();
      this._setupMessageHandlers();
      await this._checkInitialMessage();
      
      console.log('Firebase Web Notification Service initialized successfully');
    } catch (error) {
      console.error('Error initializing Firebase Web Notification Service:', error);
    }
  }

  async hasPermission() {
    try {
      return Notification.permission === 'granted';
    } catch (error) {
      console.error('Error checking notification permission:', error);
      return false;
    }
  }

  async _requestPermission() {
    if (!messaging) {
      console.warn('Firebase Messaging not supported in this browser');
      return;
    }

    let permission = Notification.permission;
    
    if (permission === 'default') {
      permission = await Notification.requestPermission();
    }
    
    console.log('User granted web notification permission:', permission);

    try {
      const token = await getToken(messaging, { vapidKey: this.vapidKey });
      if (token) {
        console.log('FCM Web Token:', token);
      } else {
        console.log('FCM Token is null. Check your Firebase configuration.');
      }
    } catch (error) {
      console.error('Error getting FCM token:', error);
    }
  }

  _setupMessageHandlers() {
    if (!messaging) {
      console.warn('Firebase Messaging not supported, skipping message handlers');
      return;
    }

    onMessage(messaging, (message) => {
      console.log('=== FOREGROUND NOTIFICATION ===');
      console.log('Got a message whilst in the foreground!');
      console.log('Message data:', message.data);

      if (message.notification) {
        const notification = message.notification;
        console.log('Message contains notification:');
        console.log('Title:', notification.title);
        console.log('Body:', notification.body);

        this._showInAppNotification(notification);
      }

      // Always process notification data for both foreground and background
      if (message.data && Object.keys(message.data).length > 0) {
        console.log('Processing notification data directly...');
        this._processNotificationData(message.data);
      }
    });
  }

  async _checkInitialMessage() {
    // Web doesn't have getInitialMessage, but we can check URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const notificationData = urlParams.get('notification_data');
    
    if (notificationData) {
      console.log('App opened from terminated state via notification!');
      console.log('Initial message data:', notificationData);
      this._handleNotificationNavigation(notificationData);
    }
  }

  _showInAppNotification(notification) {
    // Create a simple browser notification or custom UI notification
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(notification.title || 'Notification', {
        body: notification.body || '',
        icon: notification.icon || '/favicon.ico'
      });
    } else {
      console.log('Cannot show notification - no valid permission');
    }
  }

  _handleNotificationNavigationLive(payload) {
    try {
      const data = JSON.parse(payload);
      console.log('Parsed live notification payload:', data);
      this._processNotificationData(data);
    } catch (error) {
      console.error('Error parsing live notification payload:', error);
    }
  }

  _handleNotificationNavigation(payload) {
    try {
      const data = JSON.parse(payload);
      console.log('Parsed background notification payload:', data);
      this._processNotificationData(data);
    } catch (error) {
      console.error('Error parsing background notification payload:', error);
    }
  }

  _processNotificationData(data) {
    const details = data.details || {};
    const eventId = parseInt(details.eventId || data.eventId);
    const id = details.id || data.service_id;

    console.log('Debug - Raw eventId:', details.eventId || data.eventId);
    console.log('Debug - Parsed eventId:', eventId);
    console.log('Debug - ID found:', id);

    if (eventId) {
      console.log('Handling eventId:', eventId);
      switch (eventId) {
        case 50:
        console.log('Handling Event 50 - Load maintenance request details');
          break;
        case 100:
          console.log('Handling Event 100');
          break;
        case 5:
          console.log('Handling Event 5 - Load maintenance request details');
          if (id) {
            this._callTaskDetailsAPI(id);
          } else {
            console.log('No ID found for event 5');
          }
          break;
        case 120:
          console.log('Handling Event 120 - Refresh requested spare parts');
          // Call tasklist API
          this._callTaskListAPI();
          // Trigger refresh for requested spare parts
          window.dispatchEvent(new CustomEvent('refreshRequestedSpareParts'));
          break;
        case 123:
          console.log('Handling Event 123 - Refresh return spare parts');
          // Trigger refresh for return spare parts
          window.dispatchEvent(new CustomEvent('refreshReturnSpareParts'));
          break;
        case 250:
          console.log('Handling Event 250 - Load maintenance request details');
          console.log('Debug - About to call API with ID:', id);
          if (id) {
            this._callTaskDetailsAPI(id);
          } else {
            console.log('No ID found for event 250');
          }
          break;
        default:
          console.log('No matching event handler for eventId:', eventId);
          break;
      }
    } else {
      console.log('No eventId found, checking legacy type');
      const type = data.type ? parseInt(data.type) : null;
      if (type) {
        console.log('Handling legacy notification type:', type);
        switch (type) {
          case 1:
          case 2:
          case 3:
          case 5:
            break;
          case 4:
            break;
          default:
            console.log('No matching handler for notification type:', type);
            break;
        }
      } else {
        console.log('No eventId or type found in payload');
      }
    }
  }

  async getToken() {
    if (!messaging) {
      console.warn('Firebase Messaging not supported in this browser');
      return null;
    }

    try {
      const hasPermission = await this.hasPermission();
      if (!hasPermission) {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.log('Notification permission not granted');
          return null;
        }
      }

      return await getToken(messaging, { vapidKey: this.vapidKey });
    } catch (error) {
      console.error('Error getting token:', error);
      return null;
    }
  }

  async subscribeToTopic(topic) {
    try {
      // Web SDK doesn't support topic subscription directly
      // This would need to be handled server-side
      console.log('Topic subscription should be handled server-side for web:', topic);
    } catch (error) {
      console.error('Error subscribing to topic:', error);
    }
  }

  async _callTaskDetailsAPI(id) {
    try {
      console.log(`Calling maintenance details for ID: ${id}`);
      
      if (this.fetchMaintenanceDetailsCallback) {
        await this.fetchMaintenanceDetailsCallback(id, false); // Don't show loader for notification calls
        console.log('Called fetchMaintenanceDetails from context');
      } else {
        console.log('No fetchMaintenanceDetails callback available, dispatching event only');
      }
      
      // Always dispatch event for components that might be listening
      window.dispatchEvent(new CustomEvent('refreshMaintenanceDetails', { detail: { id } }));
    } catch (error) {
      console.error('Error calling maintenance details:', error);
    }
  }

  async _callTaskListAPI() {
    try {
      console.log('Calling tasklist API for notification event 120');
      
      if (this.fetchTaskListCallback) {
        await this.fetchTaskListCallback(false); // Don't show loader for notification calls
        console.log('Called fetchTaskList from context');
      } else {
        console.log('No fetchTaskList callback available, dispatching event only');
      }
      
      // Always dispatch event for components that might be listening
      window.dispatchEvent(new CustomEvent('refreshTaskList'));
    } catch (error) {
      console.error('Error calling tasklist API:', error);
    }
  }

  async unsubscribeFromTopic(topic) {
    try {
      // Web SDK doesn't support topic unsubscription directly
      // This would need to be handled server-side
      console.log('Topic unsubscription should be handled server-side for web:', topic);
    } catch (error) {
      console.error('Error unsubscribing from topic:', error);
    }
  }
}

// Create singleton instance
const firebaseNotificationService = new FirebaseNotificationService();

// Legacy functions for backward compatibility
export const requestForToken = async () => {
  return await firebaseNotificationService.getToken();
};

export const onMessageListener = (callback) => {
  if (!messaging) {
    console.warn('Firebase Messaging not supported, returning no-op unsubscribe');
    return () => {};
  }

  return onMessage(messaging, (payload) => {
    console.log("=== FOREGROUND NOTIFICATION ===");
    console.log("Payload received:", payload);
    console.log("=================================");
    
    // Process notification data for API calls
    if (payload.data && Object.keys(payload.data).length > 0) {
      firebaseNotificationService._processNotificationData(payload.data);
    }
    
    // Call the user's callback
    callback(payload);
  });
};

// Export the service instance and class
export { firebaseNotificationService, FirebaseNotificationService };


